











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DetailsItem extends Vue {
  @Prop() label!: string;
  @Prop() value!: string;
}
